import LabelCard from 'pages/UserPage/components/LabelCard';
import React, { useEffect, useState } from 'react';

import { ReactComponent as AttendanceIcon } from '../../images/refresh.svg';
import { ReactComponent as OrderCountIcon } from '../../images/bags-shopping.svg';
import { ReactComponent as OrderIntervalIcon } from '../../images/bags-clock.svg';
import { ReactComponent as BonusesIcon } from '../../images/bonuses-used.svg';
import Button from 'common/components/Button';
import { useNavigate, useOutletContext } from 'react-router-dom';
import SelectEl from 'common/components/Select';
import graphDateList from 'common/data/graphDateList';
import { SelectChangeEvent } from '@mui/material';
import IconButton from 'common/components/IconButton';
import { ReactComponent as FilterIcon } from 'common/icons/filter.svg';
import FinancesGraph from './components/OrderBar';
import CustomTable from '../../components/CustomTable';
import OrderDataTableProps from 'common/types/OrderDataTableProps';
import StatisticsBarDataProps from 'common/types/StatisticsBarDataProps';
import StatusLabel from 'common/components/StatusLabel';
import statusList from 'common/data/statusList';
import Checkbox from 'common/components/Checkbox';
import sendFetch from 'common/utils/fetch';

//   {
//     id: 1,
//     name: 'Вася Пупкін',
//     clientId: 1,
//     client: 'Вася Пупкін',
//     status: 1,
//     executorId: 1,
//     executor: 'Вася Пупкін (Важный)',
//     description: 'Одяг',
//     type: 'Ремонт',
//     price: 500,
//     discount: 0,
//     issueDate: '2021-05-05',
//     acceptanceDate: '2021-05-05',
//   },
//   {
//     id: 2,
//     name: 'Вася Пупкін',
//     clientId: 1,
//     client: 'Вася Пупкін',
//     status: 2,
//     executorId: 1,
//     executor: 'Вася Пупкін (Важный)',
//     description: 'Одяг',
//     type: 'Ремонт',
//     price: 500,
//     discount: 0,
//     issueDate: '2021-05-05',
//     acceptanceDate: '2021-05-05',
//   },
//   {
//     id: 3,
//     name: 'Вася Пупкін',
//     clientId: 1,
//     client: 'Вася Пупкін',
//     status: 3,
//     executorId: 1,
//     executor: 'Вася Пупкін (Важный)',
//     description: 'Одяг',
//     type: 'Ремонт',
//     price: 500,
//     discount: 0,
//     issueDate: '2021-05-05',
//     acceptanceDate: '2021-05-05',
//   },
//   {
//     id: 4,
//     name: 'Вася Пупкін',
//     clientId: 1,
//     client: 'Вася Пупкін',
//     status: 4,
//     executorId: 1,
//     executor: 'Вася Пупкін (Важный)',
//     description: 'Одяг',
//     type: 'Ремонт',
//     price: 500,
//     discount: 0,
//     issueDate: '2021-05-05',
//     acceptanceDate: '2021-05-05',
//   },
//   {
//     id: 5,
//     name: 'Вася Пупкін',
//     clientId: 1,
//     client: 'Вася Пупкін',
//     status: 1,
//     executorId: 1,
//     executor: 'Вася Пупкін (Важный)',
//     description: 'Одяг',
//     type: 'Ремонт',
//     price: 500,
//     discount: 0,
//     issueDate: '2021-05-05',
//     acceptanceDate: '2021-05-05',
//   },
//   {
//     id: 6,
//     name: 'Вася Пупкін',
//     clientId: 1,
//     client: 'Вася Пупкін',
//     status: 2,
//     executorId: 1,
//     executor: 'Вася Пупкін (Важный)',
//     description: 'Одяг',
//     type: 'Ремонт',
//     price: 500,
//     discount: 0,
//     issueDate: '',
//     acceptanceDate: '',
//   },
//   {
//     id: 7,
//     name: 'Вася Пупкін',
//     clientId: 1,
//     client: 'Вася Пупкін',
//     status: 3,
//     executorId: 1,
//     executor: 'Вася Пупкін (Важный)',
//     description: 'Одяг',
//     type: '',
//     price: 500,
//     discount: 0,
//     issueDate: '',
//     acceptanceDate: '',
//   },
//   {
//     id: 8,
//     name: 'Вася Пупкін',
//     clientId: 1,
//     client: 'Вася Пупкін',
//     status: 4,
//     executorId: 1,
//     executor: 'Вася Пупкін (Важный)',
//     description: '',
//     type: '',
//     price: 500,
//     discount: 0,
//     issueDate: '',
//     acceptanceDate: '',
//   },
//   {
//     id: 8,
//     name: 'Вася Пупкін',
//     clientId: 1,
//     client: 'Вася Пупкін',
//     status: 4,
//     executorId: 1,
//     executor: 'Вася Пупкін (Важный)',
//     description: '',
//     type: '',
//     price: 500,
//     discount: 0,
//     issueDate: '',
//     acceptanceDate: '',
//   },
//   {
//     id: 8,
//     name: 'Вася Пупкін',
//     clientId: 1,
//     client: 'Вася Пупкін',
//     status: 4,
//     executorId: 1,
//     executor: 'Вася Пупкін (Важный)',
//     description: '',
//     type: '',
//     price: 500,
//     discount: 0,
//     issueDate: '',
//     acceptanceDate: '',
//   },
//   {
//     id: 8,
//     name: 'Вася Пупкін',
//     clientId: 1,
//     client: 'Вася Пупкін',
//     status: 4,
//     executorId: 1,
//     executor: 'Вася Пупкін (Важный)',
//     description: '',
//     type: '',
//     price: 500,
//     discount: 0,
//     issueDate: '',
//     acceptanceDate: '',
//   },
//   {
//     id: 8,
//     name: 'Вася Пупкін',
//     clientId: 1,
//     client: 'Вася Пупкін',
//     status: 4,
//     executorId: 1,
//     executor: 'Вася Пупкін (Важный)',
//     description: '',
//     type: '',
//     price: 500,
//     discount: 0,
//     issueDate: '',
//     acceptanceDate: '',
//   },
//   {
//     id: 8,
//     name: 'Вася Пупкін',
//     clientId: 1,
//     client: 'Вася Пупкін',
//     status: 4,
//     executorId: 1,
//     executor: 'Вася Пупкін (Важный)',
//     description: '',
//     type: '',
//     price: 500,
//     discount: 0,
//     issueDate: '',
//     acceptanceDate: '',
//   },
//   {
//     id: 8,
//     name: 'Вася Пупкін',
//     clientId: 1,
//     client: 'Вася Пупкін',
//     status: 4,
//     executorId: 1,
//     executor: 'Вася Пупкін (Важный)',
//     description: '',
//     type: '',
//     price: 500,
//     discount: 0,
//     issueDate: '',
//     acceptanceDate: '',
//   },
//   {
//     id: 8,
//     name: 'Вася Пупкін',
//     clientId: 1,
//     client: 'Вася Пупкін',
//     status: 4,
//     executorId: 1,
//     executor: 'Вася Пупкін (Важный)',
//     description: '',
//     type: '',
//     price: 500,
//     discount: 0,
//     issueDate: '',
//     acceptanceDate: '',
//   },
//   {
//     id: 8,
//     name: 'Вася Пупкін',
//     clientId: 1,
//     client: 'Вася Пупкін',
//     status: 4,
//     executorId: 1,
//     executor: 'Вася Пупкін (Важный)',
//     description: '',
//     type: '',
//     price: 500,
//     discount: 0,
//     issueDate: '',
//     acceptanceDate: '',
//   },
//   {
//     id: 8,
//     name: 'Вася Пупкін',
//     clientId: 1,
//     client: 'Вася Пупкін',
//     status: 4,
//     executorId: 1,
//     executor: 'Вася Пупкін (Важный)',
//     description: '',
//     type: '',
//     price: 500,
//     discount: 0,
//     issueDate: '',
//     acceptanceDate: '',
//   },
//   {
//     id: 8,
//     name: 'Вася Пупкін',
//     clientId: 1,
//     client: 'Вася Пупкін',
//     status: 4,
//     executorId: 1,
//     executor: 'Вася Пупкін (Важный)',
//     description: '',
//     type: '',
//     price: 500,
//     discount: 0,
//     issueDate: '',
//     acceptanceDate: '',
//   },
//   {
//     id: 8,
//     name: 'Вася Пупкін',
//     clientId: 1,
//     client: 'Вася Пупкін',
//     status: 4,
//     executorId: 1,
//     executor: 'Вася Пупкін (Важный)',
//     description: '',
//     type: '',
//     price: 500,
//     discount: 0,
//     issueDate: '',
//     acceptanceDate: '',
//   },
//   {
//     id: 8,
//     name: 'Вася Пупкін',
//     clientId: 1,
//     client: 'Вася Пупкін',
//     status: 4,
//     executorId: 1,
//     executor: 'Вася Пупкін (Важный)',
//     description: '',
//     type: '',
//     price: 500,
//     discount: 0,
//     issueDate: '',
//     acceptanceDate: '',
//   },
//   {
//     id: 8,
//     name: 'Вася Пупкін',
//     clientId: 1,
//     client: 'Вася Пупкін',
//     status: 4,
//     executorId: 1,
//     executor: 'Вася Пупкін (Важный)',
//     description: '',
//     type: '',
//     price: 500,
//     discount: 0,
//     issueDate: '',
//     acceptanceDate: '',
//   },
//   {
//     id: 8,
//     name: 'Вася Пупкін',
//     clientId: 1,
//     client: 'Вася Пупкін',
//     status: 4,
//     executorId: 1,
//     executor: 'Вася Пупкін (Важный)',
//     description: '',
//     type: '',
//     price: 500,
//     discount: 0,
//     issueDate: '',
//     acceptanceDate: '',
//   },
//   {
//     id: 8,
//     name: 'Вася Пупкін',
//     clientId: 1,
//     client: 'Вася Пупкін',
//     status: 4,
//     executorId: 1,
//     executor: 'Вася Пупкін (Важный)',
//     description: '',
//     type: '',
//     price: 500,
//     discount: 0,
//     issueDate: '',
//     acceptanceDate: '',
//   },
//   {
//     id: 8,
//     name: 'Вася Пупкін',
//     clientId: 1,
//     client: 'Вася Пупкін',
//     status: 4,
//     executorId: 1,
//     executor: 'Вася Пупкін (Важный)',
//     description: '',
//     type: '',
//     price: 500,
//     discount: 0,
//     issueDate: '',
//     acceptanceDate: '',
//   },
  
// ];

const mockData: StatisticsBarDataProps[] = [
  {
    indexBy: 'Пн',
    accepted: Math.floor(Math.random() * 10),
    acceptedColor: '#81B7F8',
    inWork: Math.floor(Math.random() * 10),
    inWorkColor: '#8B81F8',
    completed: Math.floor(Math.random() * 10),
    completedColor: '#C481F8',
    inWarehouse: Math.floor(Math.random() * 10),
    inWarehouseColor: '#F881D7',
    canceled: Math.floor(Math.random() * 10),
    canceledColor: '#F88181',
  },
  {
    indexBy: 'Вт',
    accepted: Math.floor(Math.random() * 10),
    acceptedColor: '#81B7F8',
    inWork: Math.floor(Math.random() * 10),
    inWorkColor: '#8B81F8',
    completed: Math.floor(Math.random() * 10),
    completedColor: '#C481F8',
    inWarehouse: Math.floor(Math.random() * 10),
    inWarehouseColor: '#F881D7',
    canceled: Math.floor(Math.random() * 10),
    canceledColor: '#F88181',
  },
  {
    indexBy: 'Ср',
    accepted: Math.floor(Math.random() * 10),
    acceptedColor: '#81B7F8',
    inWork: Math.floor(Math.random() * 10),
    inWorkColor: '#8B81F8',
    completed: Math.floor(Math.random() * 10),
    completedColor: '#C481F8',
    inWarehouse: Math.floor(Math.random() * 10),
    inWarehouseColor: '#F881D7',
    canceled: Math.floor(Math.random() * 10),
    canceledColor: '#F88181',
  },
  {
    indexBy: 'Чт',
    accepted: Math.floor(Math.random() * 10),
    acceptedColor: '#81B7F8',
    inWork: Math.floor(Math.random() * 10),
    inWorkColor: '#8B81F8',
    completed: Math.floor(Math.random() * 10),
    completedColor: '#C481F8',
    inWarehouse: Math.floor(Math.random() * 10),
    inWarehouseColor: '#F881D7',
    canceled: Math.floor(Math.random() * 10),
    canceledColor: '#F88181',
  },
  {
    indexBy: 'Пт',
    accepted: Math.floor(Math.random() * 10),
    acceptedColor: '#81B7F8',
    inWork: Math.floor(Math.random() * 10),
    inWorkColor: '#8B81F8',
    completed: Math.floor(Math.random() * 10),
    completedColor: '#C481F8',
    inWarehouse: Math.floor(Math.random() * 10),
    inWarehouseColor: '#F881D7',
    canceled: Math.floor(Math.random() * 10),
    canceledColor: '#F88181',
  },
  {
    indexBy: 'Сб',
    accepted: Math.floor(Math.random() * 10),
    acceptedColor: '#81B7F8',
    inWork: Math.floor(Math.random() * 10),
    inWorkColor: '#8B81F8',
    completed: Math.floor(Math.random() * 10),
    completedColor: '#C481F8',
    inWarehouse: Math.floor(Math.random() * 10),
    inWarehouseColor: '#F881D7',
    canceled: Math.floor(Math.random() * 10),
    canceledColor: '#F88181',
  },
  {
    indexBy: 'Нд',
    accepted: Math.floor(Math.random() * 10),
    acceptedColor: '#81B7F8',
    inWork: Math.floor(Math.random() * 10),
    inWorkColor: '#8B81F8',
    completed: Math.floor(Math.random() * 10),
    completedColor: '#C481F8',
    inWarehouse: Math.floor(Math.random() * 10),
    inWarehouseColor: '#F881D7',
    canceled: Math.floor(Math.random() * 10),
    canceledColor: '#F88181',
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any

type BarChecks = {
  accepted: boolean;
  inWork: boolean;
  completed: boolean;
  inWarehouse: boolean;
  canceled: boolean;
};

type ResponseProps = {
  status?: string;
  statusCode: number | string;
  orderList?: OrderDataTableProps[];
} | string;

type ResponseArray = [number, ResponseProps];

export default function UserStatisticsPage() {
  //const [graphData] = useState<GraphData[]>(mockData);
  //   const [dayCount, setDayCount] = useState<number>(7);
  //   const [xType, setXType] = useState<'days' | 'weeks' | 'months'>('days');
  const [graphDate, setGraphDate] = useState<number>(1);
  const [checks, setChecks] = useState<BarChecks>({
    accepted: true,
    inWork: true,
    completed: true,
    inWarehouse: true,
    canceled: true,
  });
  const [bonusSpent, setBonusSpent] = useState<number>(0);
  const [orderCount, setOrderCount] = useState<number>(0);
  const [orderInterval, setOrderInterval] = useState<string>('00:00:00');
  const [averageMonthlyTraffic, setAverageMonthlyTraffic] = useState<number>(0);
  const navigate = useNavigate();
  const handleReturn = () => {
    navigate(-1);
  };

  const handleCheckPress = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
    setChecks((prev) => ({ ...prev, [name]: checked }));
  };


  const handleGraphDateChange = (event: SelectChangeEvent) => {
    setGraphDate(parseInt(event.target.value));
  };
  
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  
  const keys: string[] = [
    checks.accepted ? 'accepted' : '',
    checks.inWork ? 'inWork' : '',
    checks.completed ? 'completed' : '',
    checks.inWarehouse ? 'inWarehouse' : '',
    checks.canceled ? 'canceled' : '',
  ];

  // fetch orders
  const [tableData, setTableData] = useState<OrderDataTableProps[]>([]);
  const [tableLoading, setTableLoading] = useState(false);
  const { userId }:{ userId: string } = useOutletContext();
  console.log(`userId: ${userId}`);

  useEffect(() => {
    const fetchTableData = async () => {
      setTableLoading(true);
      const link = 'https://api-workspace.astin.net/api/statistic/get-order-list-by-user-id';
      const response: ResponseArray = await sendFetch(`${link}`, {
        method: 'GET',
        params: {
          userId: userId,
        },
      });
      console.log(response);
      if (typeof response[1] === 'object' && 'statusCode' in response[1]) {
        if (response[0] === 200 && response[1].statusCode == 200 ) {
          setTableLoading(false);
          setTableData(response[1].orderList || []);
        } else {
          setTableLoading(false);
        }
      } else {
        setTableLoading(false);
      }
    };
    const fetchStatisticsInfo = async () => {
      const link = 'https://api-workspace.astin.net/api/statistic/get-statistic-info';
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const response: [number, any] = await sendFetch(`${link}`, {
        method: 'GET',
        params: {
          userId: userId,
        },
      });
      console.log(response);
      if (response[0] === 200 && response[1]?.statusCode == 200) {
        setAverageMonthlyTraffic(response[1].averageMonthlyTraffic);
        setOrderCount(response[1].orderCount);
        setOrderInterval(response[1].orderInterval);
        setBonusSpent(response[1].bonusSpent);
      }
    };
    if (userId) {
      fetchTableData();
      fetchStatisticsInfo();
    }
  }, [userId]);

  return (
        <>
            <div className='user-finances-label-card-wrapper'>
                <LabelCard icon={<AttendanceIcon className='svg-black' />} title='Середня відвідуваність' value={averageMonthlyTraffic} />
                <LabelCard icon={<OrderCountIcon className='svg-black' />} title='Кількість замовлень' value={orderCount} />
                <LabelCard icon={<OrderIntervalIcon className='svg-black' />} title='Інтервал замовлень' value={orderInterval} />
                <LabelCard icon={<BonusesIcon className='svg-black' />} title='Використані бонуси' value={bonusSpent} />
            </div>
            <div className='user-stats-wrapper'>
                <div className='user-stats-element'>
                  <CustomTable loading={tableLoading} data={typeof tableData === 'object' && tableData} />
                </div>
                <div className='user-stats-element'>
                    <div className='user-stats-inner-position'>
                        <div className='user-stats-top-wrapper'>
                            <span className='big-text'>Фінанси</span>
                            <div className='user-stats-top-right'>
                                <SelectEl
                                    data={graphDateList}
                                    value={graphDate}
                                    onChange={handleGraphDateChange}
                                    height='40px'
                                />
                                <IconButton>
                                    <FilterIcon className='svg-black' />
                                </IconButton>
                            </div>
                        </div>
                        <div style={{ flex:1, position:'relative' }}>
                            <div className='user-stats-graph-wrapper'>
                                <FinancesGraph keys={keys} data={mockData} />
                            </div>
                        </div>
                        <div className='user-stats-filter-wrapper'>
                          <h3 className='new-h3'>Оберіть статуси:</h3>
                          <div className='user-stats-filter-checks-wrapper'>
                            <div className='user-stats-check-wrapper'>
                              <Checkbox checked={checks.accepted} onChange={handleCheckPress} name='accepted' marginRight={0} />
                              <StatusLabel color={statusList[0].color} status={statusList[0].label} />
                            </div>
                            <div className='user-stats-check-wrapper'>
                              <Checkbox checked={checks.inWork} onChange={handleCheckPress} name='inWork' marginRight={0} />
                              <StatusLabel color={statusList[1].color} status={statusList[1].label} />
                            </div>
                            <div className='user-stats-check-wrapper'>
                              <Checkbox checked={checks.completed} onChange={handleCheckPress} name='completed' marginRight={0} />
                              <StatusLabel color={statusList[2].color} status={statusList[2].label} />
                            </div>
                            <div className='user-stats-check-wrapper'>
                              <Checkbox checked={checks.inWarehouse} onChange={handleCheckPress} name='inWarehouse' marginRight={0} />
                              <StatusLabel color={statusList[3].color} status={statusList[3].label} />
                            </div>
                            <div className='user-stats-check-wrapper'>
                              <Checkbox checked={checks.canceled} onChange={handleCheckPress} name='canceled' marginRight={0} />
                              <StatusLabel color={statusList[4].color} status={statusList[4].label} />
                            </div>
                          </div>
                          
                        </div>
                    </div>
                </div>
            </div>
            <div className='user-button-wrapper right'>
                <Button type='button' onClick={handleReturn} label='Повернутись' />
            </div>
        </>
  );
}

